<template>
  <span class="plus-minus-sign"> </span>
</template>

<script src="./plus-minus-sign.js"></script>
<style src="./plus-minus-sign.scss" lang="scss"></style>
